import { render, staticRenderFns } from "./leadData.vue?vue&type=template&id=7622c690&scoped=true&"
import script from "./leadData.vue?vue&type=script&lang=js&"
export * from "./leadData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7622c690",
  null
  
)

export default component.exports